define.alias("shared/utils/image-tag", "calendar/utils/image-tag");